import React from 'react';
import { MetaData } from '../models';

const MetaDataContext = React.createContext<MetaData | undefined>(undefined);

export default MetaDataContext;
